"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Placeholder = Placeholder;
var _hooks = require("@a1s/hooks");
var _react = _interopRequireWildcard(require("react"));
var _rough = _interopRequireDefault(require("roughjs/bundled/rough.esm"));
var _ = require("../../");
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const generator = _rough.default.generator();

//
// Main component
// -------------------------------------------------------------------------------------------------
function Placeholder({
  kind = 'drawn',
  ...props
}) {
  if (kind === 'basic') return /*#__PURE__*/_react.default.createElement(BasicPlaceholder, props);
  return /*#__PURE__*/_react.default.createElement(DrawnPlaceholder, props);
}

//
// Private components
// -------------------------------------------------------------------------------------------------

function BasicPlaceholder({
  testId,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_.Box, _extends({
    bg: "$gray200",
    "data-testid": testId
  }, props, {
    p: "5",
    r: "4"
  }));
}
function DrawnPlaceholder({
  children,
  seed = _rough.default.newSeed(),
  testId,
  ...props
}) {
  const baseRef = (0, _react.useRef)(null);
  const seedRef = (0, _react.useRef)(seed);
  const svgRef = (0, _react.useRef)(null);
  const {
    height,
    width
  } = (0, _hooks.useDimensions)(baseRef);
  const rectangle = (0, _react.useMemo)(() => {
    return generator.rectangle(5, 5, width - 10, height - 10, {
      fill: 'true',
      roughness: 1.25,
      seed: seedRef.current
    });
  }, [height, width]);
  return /*#__PURE__*/_react.default.createElement(_styled.BaseContainer, _extends({
    "data-testid": testId,
    ref: baseRef
  }, props), /*#__PURE__*/_react.default.createElement(_styled.RootSVG, {
    ref: svgRef
  }, rectangle.sets.map(drawing => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: drawing.path
  }, drawing.type === 'path' && /*#__PURE__*/_react.default.createElement(_styled.BorderPath, {
    d: generator.opsToPath(drawing)
  }), drawing.type === 'fillSketch' && /*#__PURE__*/_react.default.createElement(_styled.FillPath, {
    d: generator.opsToPath(drawing)
  }))), children && /*#__PURE__*/_react.default.createElement(_styled.TextCenterer, null, /*#__PURE__*/_react.default.createElement("text", {
    dominantBaseline: "middle",
    textAnchor: "middle",
    x: "50%",
    y: "50%"
  }, children)), /*#__PURE__*/_react.default.createElement(_styled.HiddenRect, {
    height: height,
    width: width,
    x: "0",
    y: "0"
  })));
}